"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: var(--color-primary-light-3);\n  font-size: var(--font-size-small);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 15rem;\n\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 1rem 1.25rem;\n  background-color: #fff;\n  border: 1px solid var(--color-grey-light-3);\n  box-shadow: var(--box-shadow-node);\n\n  max-width: ", ";\n\n  ", "\n\n  & > :first-child {\n    margin: 0.5rem 0 0.75rem 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  transition: transform 0.2s;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(1);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var MAX_IMAGE_CARD_WIDTH = '35rem';
var clickableStyle = styled_components_1.css(_templateObject());
exports.StyledImageCardDiv = styled_components_1.default.div(_templateObject2(), MAX_IMAGE_CARD_WIDTH, function (_ref) {
  var clickable = _ref.clickable;
  return clickable && clickableStyle;
});
exports.StyledImageViewDiv = styled_components_1.default.div(_templateObject3(), function (_ref2) {
  var imageUrl = _ref2.imageUrl;
  return imageUrl && "url(\"".concat(imageUrl, "\")");
});
exports.StyledImageNameSpan = styled_components_1.default.span(_templateObject4());